export function adRenderSuccess(callback) {
  document.addEventListener('adRenderSuccess', (e) => {
    callback();
  });
  callback();
}
